import { AssociationSelection, AtonementAmountSelection, OrderSummary, Payment, PersonalDetails, KitSelection, StationSelection, ItemSelection } from "../components/purchase";
import { Step } from '../types';

export const purchaseSteps: Step[] = [
	{ title: ({ p }) => p.personalDetails, component: PersonalDetails },
	{ title: ({ p }) => p.selectKit, component: KitSelection, isFreeSale: false },
	{ title: ({ p }) => p.selectItems, component: ItemSelection, isFreeSale: true },
	{ title: ({ p }) => p.selectStation, component: StationSelection, isFreeSale: false },
	{ title: ({ p }) => p.selectAssociation, component: AssociationSelection },
	{ title: ({ p }) => p.atonementTitle, label: ({ p }) => p.atonementLabel, component: AtonementAmountSelection },
	{ title: ({ p }) => p.orderSummary, label: ({ p }) => p.orderSummaryLabel, component: OrderSummary },
	{ title: ({ p }) => p.payment, hideNavigation: true, component: Payment }
]